import {
  AkaFamilyAccidentCoverage,
  InsuranceCoverage,
} from "Store/interfaces/products/coverage";
import { isDefined } from "Utils/functions";
import { FormikProps } from "formik";
import { AkaFamilyAccidentProductIntroFormValues } from "./ProductIntro/akaFamilyAccidentProductIntroInterfaces";
import { AkaFamilyAccidentProductPriceFormValues } from "./ProductPrice/akaFamilyAccidentProductPriceInterfaces";

export const setAkaFamilyAccidentCoverage = (
  formValues:
    | AkaFamilyAccidentProductIntroFormValues
    | AkaFamilyAccidentProductPriceFormValues,
): AkaFamilyAccidentCoverage | undefined => {
  if (formValues.hasDeathCoverage) {
    if (formValues.hasDisabilityCoverage) {
      if (formValues.hasProfessionalDisabilityCoverage) {
        return AkaFamilyAccidentCoverage.AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY_AND_PROFESSIONAL_DISABILITY;
      }
      return AkaFamilyAccidentCoverage.AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY;
    }
    return AkaFamilyAccidentCoverage.AKA_FAMILY_ACCIDENT_DEATH;
  }

  if (formValues.hasDisabilityCoverage) {
    if (formValues.hasProfessionalDisabilityCoverage) {
      return AkaFamilyAccidentCoverage.AKA_FAMILY_ACCIDENT_DISABILITY_AND_PROFESSIONAL_DISABILITY;
    }
    return AkaFamilyAccidentCoverage.AKA_FAMILY_ACCIDENT_DISABILITY;
  }
  return undefined;
};

export const toggleProfessionalDisabilityCoverage = (
  value: boolean,
  formProps:
    | FormikProps<AkaFamilyAccidentProductIntroFormValues>
    | FormikProps<AkaFamilyAccidentProductPriceFormValues>,
): void => {
  if (!value) {
    formProps.setFieldValue("hasProfessionalDisabilityCoverage", false);
  }
};

export const hasNotSelectedCoverage = (
  formProps: FormikProps<AkaFamilyAccidentProductIntroFormValues>,
): boolean => {
  return !!(
    !formProps.values.hasDisabilityCoverage &&
    !formProps.values.hasDeathCoverage &&
    (formProps.touched.hasDeathCoverage ||
      formProps.touched.hasDisabilityCoverage)
  );
};

export const isAkaFamilyAccidentCoverage = (
  coverage?: InsuranceCoverage,
): boolean =>
  isDefined(coverage) &&
  (<any>Object).values(AkaFamilyAccidentCoverage).includes(coverage);
